export const apiURL = process.env.REACT_APP_API_URL
export const backURL = process.env.REACT_APP_BACK_URL
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID
export const URL_AUTHORIZE = process.env.REACT_APP_URL_AUTHORIZE
export const SCOPE = process.env.REACT_APP_SCOPE
export const URL_CALLBACK = process.env.REACT_APP_URL_CALLBACK
export const URL_SSO = process.env.REACT_APP_URL_SSO
export const appURL= process.env.REACT_APP_APP_URL
